import { render, staticRenderFns } from "./AddUserProfile.vue?vue&type=template&id=0c97923c"
import script from "./AddUserProfile.vue?vue&type=script&lang=js"
export * from "./AddUserProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports